/**
 * Global Interval Manager
 * Manages all polling intervals and cleans them up on logout
 */

class IntervalManager {
  constructor() {
    this.intervals = new Set();
  }

  register(intervalId) {
    this.intervals.add(intervalId);
    return intervalId;
  }

  unregister(intervalId) {
    clearInterval(intervalId);
    this.intervals.delete(intervalId);
  }

  clearAll() {
    this.intervals.forEach(id => clearInterval(id));
    this.intervals.clear();
    // Also clear all caches
    try {
      sessionStorage.removeItem('dashboardData');
      sessionStorage.removeItem('historyData');
      // Clear all progress caches
      Object.keys(sessionStorage).forEach(key => {
        if (key.startsWith('progress_')) {
          sessionStorage.removeItem(key);
        }
      });
    } catch (e) {
      console.error('Error clearing cache:', e);
    }
  }
}

export const intervalManager = new IntervalManager();
